export default {
  BIF: {
    symbol: 'FBu',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  CVE: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KMF: {
    symbol: 'CF',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  CDF: {
    symbol: 'FC',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  DJF: {
    symbol: 'Fdj',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ERN: {
    symbol: 'ናቕፋ',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  GNF: {
    symbol: 'FG',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  LSL: {
    symbol: 'L',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  LYD: {
    symbol: 'ل.د',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MWK: {
    symbol: 'MK',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MRO: {
    symbol: 'UM',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SLL: {
    symbol: 'LE',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SZL: {
    symbol: 'L',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  TJS: {
    symbol: 'TJS',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  TOP: {
    symbol: 'T$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  XPF: {
    symbol: 'F',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  XOF: {
    symbol: 'CFA',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  XAF: {
    symbol: 'FCFA',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  WST: {
    symbol: 'WS$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  VUV: {
    symbol: 'VT',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  UGX: {
    symbol: 'USh',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  TZS: {
    symbol: 'TSh',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  STD: {
    symbol: 'Db',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  RWF: {
    symbol: 'R₣',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  PGK: {
    symbol: 'K',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MVR: {
    symbol: 'Rf',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MOP: {
    symbol: 'MOP$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MMK: {
    symbol: 'K',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MDL: {
    symbol: 'L',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  HTG: {
    symbol: 'G',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  GMD: {
    symbol: 'D',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  GEL: {
    symbol: 'GEL',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ETB: {
    symbol: 'Br',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BTN: {
    symbol: 'Nu.',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BDT: {
    symbol: '৳',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  AOA: {
    symbol: 'Kz',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  AED: {
    symbol: 'AED',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MGA: {
    symbol: 'Ar',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  GHS: {
    symbol: 'GH₵',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  TMT: {
    symbol: 'T',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  DZD: {
    symbol: 'دج',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MAD: {
    symbol: 'د.م.',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KWD: {
    symbol: 'د.ك',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  TND: {
    symbol: 'د.ت',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  AZN: {
    symbol: 'ман',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BGL: {
    symbol: 'лв',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    isDisabled: true,
  },
  BGN: {
    symbol: 'лв',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  UZS: {
    symbol: 'сум',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KZT: {
    symbol: '₸',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KGS: {
    symbol: 'сом',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  RSD: {
    symbol: 'РСД',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MKD: {
    symbol: 'ден',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  TTD: {
    symbol: 'TT$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  PEN: {
    symbol: 'S/.',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SOS: {
    symbol: 'S',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  IDR: {
    symbol: 'Rp',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  DOP: {
    symbol: 'RD$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ZAR: {
    symbol: 'R',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  GTQ: {
    symbol: 'Q',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BYN: {
    symbol: 'BYR',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BWP: {
    symbol: 'P',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MZN: {
    symbol: 'MT',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ALL: {
    symbol: 'Lek',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  RON: {
    symbol: 'lei',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  HNL: {
    symbol: 'L',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KES: {
    symbol: 'Ksh',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ISK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  HRK: {
    symbol: 'kn',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BAM: {
    symbol: 'KM',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  JOD: {
    symbol: 'JD',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  JMD: {
    symbol: 'J$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  PYG: {
    symbol: 'Gs',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  AWG: {
    symbol: 'ƒ',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ANG: {
    symbol: 'ƒ',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  NIO: {
    symbol: 'C$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BZD: {
    symbol: 'BZ$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  VEF: {
    symbol: 'Bs',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  PAB: {
    symbol: 'B/.',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  YER: {
    symbol: '﷼',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SAR: {
    symbol: '﷼',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  QAR: {
    symbol: '﷼',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  OMR: {
    symbol: '﷼',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SCR: {
    symbol: '₨',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  PKR: {
    symbol: '₨',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  NPR: {
    symbol: '₨',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MUR: {
    symbol: '₨',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  LKR: {
    symbol: '₨',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  UAH: {
    symbol: '₴',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  MNT: {
    symbol: '₮',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  LAK: {
    symbol: '₭',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  VND: {
    symbol: '₫',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KRW: {
    symbol: '₩',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  NGN: {
    symbol: '₦',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  CRC: {
    symbol: '₡',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KHR: {
    symbol: '៛',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  AFN: {
    symbol: '؋',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  CNY: {
    symbol: '¥',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  FKP: {
    symbol: '£',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SHP: {
    symbol: '£',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  GIP: {
    symbol: '£',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  LBP: {
    symbol: '.ل.ل',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  EGP: {
    symbol: '£',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  UYU: {
    symbol: '$U',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BOB: {
    symbol: '$b',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BMD: {
    symbol: 'BD$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SBD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  XCD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  LRD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  KYD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  GYD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  FJD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  COP: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  CLP: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BSD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BND: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BBD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ARS: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  NAD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  SRD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  BHD: {
    symbol: '.د.ب',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  AMD: {
    symbol: 'AMD',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  TRY: {
    symbol: '₺',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  INR: {
    symbol: '₹',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  IQD: {
    symbol: 'ع.د',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
  ZMW: {
    symbol: 'ZK',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    rent: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
    sale: {
      min: 0.01,
      max: 100000,
      default: 1,
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared/constants/bm-additional-currencies.js